/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../theme';
import { ROUTES } from '../routes';
import { Home, Search, PlusCircle, MessageSquare, User } from 'lucide-react';

const BottomNav: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: ROUTES.HOME, icon: Home },
    { label: 'Search', path: ROUTES.SEARCH, icon: Search },
    { label: 'Sell', path: ROUTES.ADD_LISTING, icon: PlusCircle },
    { label: 'Messages', path: ROUTES.MESSAGES, icon: MessageSquare },
    { label: 'Profile', path: ROUTES.DASHBOARD, icon: User },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 border-t flex justify-around items-center px-2 py-3 z-50 shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.1)]" 
         style={{ backgroundColor: theme.colors.surface, borderColor: theme.colors.border }}>
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path || (item.path !== ROUTES.HOME && location.pathname.startsWith(item.path));
        
        return (
          <Link
            key={item.label}
            to={item.path}
            className="flex flex-col items-center gap-1 min-w-[60px] transition-all duration-300"
            style={{ color: isActive ? theme.colors.primary : theme.colors.mutedText }}
          >
            <div className={`p-1.5 rounded-xl transition-all ${isActive ? 'bg-blue-50' : ''}`}>
              <Icon size={20} strokeWidth={isActive ? 3 : 2} />
            </div>
            <span className={`text-[10px] font-black uppercase tracking-tighter ${isActive ? 'opacity-100' : 'opacity-60'}`}>
              {item.label}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default BottomNav;
